export default __webpack_public_path__ + "static/media/gallery_02.34ff3f73.jpg";